<template>
  <div class="tag-list"></div>
</template>
<script>
export default {
  props: {},
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped></style>
